import { Tuple } from "~/tools/tuple";
import { theme } from "~/tools/twin-migration";

const CRITICAL = theme("colors.graph-red.20");
const WARNING = theme("colors.graph-orange.20");
const HEALTHY = theme("colors.graph-green.20");

const PRESET = Tuple(CRITICAL, WARNING, theme("colors.graph-blue.20"), HEALTHY, theme("colors.graph-purple.20"));

export { CRITICAL, WARNING, HEALTHY, PRESET };
